import React, { ButtonHTMLAttributes, ReactElement, ReactNode } from 'react';
import { StylingSizes, StylingVariants } from '@/theme/styles.types.ts';

// Basic button props extended from native button attributes
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	linkReplace?: boolean;
	label?: string; // Text to display on the button
	children?: ReactNode;
	size?: StylingSizes;
	variant?: StylingVariants;
	theme?: 'outline' | 'solid';
	asLink?: boolean; // Determines if the button should render as a Link
	to?: string; // Destination for link-type buttons
	icon?: ReactNode; // Icon to display alongside the button text
	onClick?: (
		e: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined
	) => Promise<unknown|void> | void; // renamed prop
}

export interface LoaderButtonProps extends ButtonProps {
	labels?: LabelObject;
	resetAfterComplete?: boolean;
	isLoading?: boolean;
}

export interface ILoaderButtonState {
	isLoading: boolean;
	isCompleted: boolean;
	isLocked: boolean;
	hasFailed: boolean;
	slugState: string;
}

export interface IButtonWithIcon extends ButtonProps {
	icon: ReactElement;
}

export const BUTTON_STATES = {
	IDLE: 'idle',
	LOADING: 'loading',
	COMPLETED: 'completed',
	ERROR: 'error',
} as const;

export type ButtonState = typeof BUTTON_STATES[keyof typeof BUTTON_STATES];

export interface LabelObject {
	idle: string;
	loading?: string;
	completed?: string;
	error?: string;
}